import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { responseError } from '../../../../helpers/response/ResponseHelper'
import ErrorMessage from '../../../UI/messages/ErrorMessage'
import AddTabs from '../../../addTabs/AddTabs'
import SupplyBillAbout from './about/SupplyBillAbout'
import SupplyBillClient from './client/SupplyBillClient'
import { getSupplyBillAPI } from '../../../../api/supply/supplyBillAPI'
import SupplyBilItemsInBill from './items/SupplyBilItemsInBill'
import SupplyBillPayments from './payments/SupplyBillPayments'
import SupplyBillDeliveries from './delivery/SupplyBillDeliveries'
import { useDispatch, useSelector } from 'react-redux'
import { setSupplyBill } from '../../../../store/supplyBillSlice'
import SupplyBillFiles from './files/SupplyBillFiles'

const SupplyBillView = ({ supplyBillId }) => {

    const supplyBill = useSelector(state => state.supplyBill.supplyBill)
    const dispatch = useDispatch()
    // const [supplyBill, setSupplyBill] = useState('')

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        getSupplyBill()
    }, [supplyBillId])

    const getSupplyBill = () => {
        setLoading(true)

        getSupplyBillAPI({ supplyBillId }).then(data => {
            // setSupplyBill(data)
            dispatch(setSupplyBill(data))
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='supplyOrderView'>
        <ErrorMessage error={error} />
        {
            !error ?
                <>
                    <div className='supplyOrderView__left'>
                        <div className='supplyOrderView__top'>
                            <SupplyBillAbout
                                supplyBill={supplyBill}
                            />
                            <SupplyBillClient 
                                supplyBillId={supplyBillId}
                                // user={supplyBill.user}
                                // supplier={supplyBill.supplier}
                            />
                            {/* <SupplyOrderApproval /> */}
                            {/* <SupplyOrderComments /> */}
                        </div>
                        <div>
                            <SupplyBillFiles 
                                supplyBillId={supplyBillId}
                            />
                        </div>
                        <SupplyBilItemsInBill
                            supplyBillId={supplyBillId}
                            // supplyBillItems={supplyBill.items}
                        />
                        <SupplyBillPayments 
                            supplyBillId={supplyBillId}
                            // billPayments={supplyBill.billPayments}
                        />
                        <SupplyBillDeliveries 
                            supplyBillId={supplyBillId}
                            // deliveries={supplyBill.deliveries}
                        />
                        {/* <SupplyOrderBills 
                            supplyOrderId={supplyOrderId}
                        /> */}
                    </div>
                    <div className='supplyOrderView__right'>
                        <AddTabs
                            comments={supplyBill.comments}
                            changes={supplyBill.changes}
                            supplyBillId={supplyBillId}
                        />
                    </div>
                </>
            : ''
        }
    </div>
  )
}

export default SupplyBillView